<template>
    <div class="building-container">
        <el-empty :image="image" :image-size="size"></el-empty>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    const emptyImgs = {
        'building': require('@assets/images/building-tip.png'),
        'none': require('@assets/images/building-none.png'),
        '404': require('@assets/images/error-404.png'),
    }
    export default {
        name: 'workspace',
        props: {
            flag: {
                type: String,
                default: 'building'
            },
            size: {
                type: Number,
                default: 640
            }
        },
        data() {
            return {
                image: emptyImgs[this.flag]
            }
        },
        methods: {
            handleLogout() {
                this.$store.dispatch('user/logout');
            }
        },
        computed: {
            ...mapState('user', ['userProject'])
        }
    }
</script>

<style lang="scss" scoped>
    .building-container {
        min-height: 100%;
        background: #fff;
        border-radius: 8px;
        padding-top: 10%;
    }
    :deep(.el-empty__description) {
        display: none !important;
    }
</style>